import type { IconSvgObject } from './types';

const RukuIcon: IconSvgObject = [
  ["path", { d: "M15.5 3.5H18.1247C19.4365 3.5 20.5 4.50731 20.5 5.74989C20.5 6.99247 19.4365 7.99978 18.1247 7.99978H15.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.8317 6.98546L10.0207 9.99998V14.8978M10.0207 14.8978V18.5L3.5 18.5V9.60934C3.5 5.68295 6.71707 2.49997 10.6855 2.49997H14C15.1046 2.49997 16 3.3954 16 4.49997V7.99989L10.0207 14.8978Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18.5V21.5M9 21.5H5.5V18.5M9 21.5H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RukuIcon;
